export const CommonConstants = {
    uom: {
        pound: 150,
        kg: 151,
        inch: 200,
        cm: 201,
        lookupByUom: { 150: 'lbs', 151: 'Kg', 200: 'in', 201: 'cm' }
    },
    variableDosingTypes: {
        bmi: 50,
        weightRange: 51,
        weight: 52
    },
    rangeTypeCodes: {
        between: 100,
        greaterThanOrEqualTo: 101
    },
    nuctracEssentialID: 5,
    Daily: 11500,
    Weekly: 11501,
    Monthly: 11502,

    scheduleTypeCodes: [{ "id": 251, "name": "Weekly" }, { "id": 252, "name": "Day of Month" }, { "id": 253, "name": "Week Day of Month" }],
    pediatricDosingTypes: {
        dosingTable: 11200,
        imageGently: 11201
    },
    noOrderCreated: 'No Order Created'
}